import {
    ownerActions,
    ownerThunks as defaultThunks,
    ownerSelectors as defaultSelectors,
    ownerReducer,
} from './Owner-slice';
import * as thunks from './Owner-thunks';
import * as selectors from './Owner-selectors';

const ownerThunks = { ...defaultThunks, ...thunks };
const ownerSelectors = { ...defaultSelectors, ...selectors };

export { ownerSelectors, ownerActions, ownerThunks, ownerReducer };
